export const SEGMENT_BY = [
  {
    label: "Customer Class",
    value: "customer_class",
    defaultSelected: true,
  },
  {
    label: "Target Variable",
    value: "target_var",
    defaultSelected: true,
  },
  {
    label: "Dwelling Type",
    value: "dwelling_type",
    defaultSelected: true,
  },
  {
    label: "Target Variable Bands",
    value: "target_var_bands",
    defaultSelected: true,
  },
  {
    label: "PV Type",
    value: "pv_type",
    defaultSelected: false,
  },
  {
    label: "Tariff",
    value: "tariff",
    defaultSelected: false,
  },
  {
    label: "Vintage",
    value: "vintage",
    defaultSelected: false,
  },
  {
    label: "Weather Zone",
    value: "weather_zone",
    defaultSelected: false,
  },
];

export const SIMULATION_CONFIDENCE_INTERVAL = [
  {
    label: "50/50",
    value: "50/50",
    disabled: false,
  },
  {
    label: "75/25",
    value: "75/25",
    disabled: false,
  },
  {
    label: "90/10",
    value: "90/10",
    disabled: false,
  },
  {
    label: "95/5",
    value: "95/5",
    disabled: false,
  },
];
